import type { PushNotificationService } from "../types"

// Web (PWA) build: native OS push is not wired up here — the mobile app's
// "native only" scope keeps the PWA on its existing Web-Notification/toast
// path (see useNewTaskToasts). This no-op reports "unsupported" so callers
// fall back to that surface instead of trying to register a device token.
export const pushNotifications: PushNotificationService = {
  async isSupported() {
    return false
  },
  getPlatform() {
    return null
  },
  async getPermissionState() {
    // Never actually read (callers gate on isSupported() first); "prompt"
    // is the least-misleading neutral value.
    return "prompt"
  },
  async register() {
    return null
  },
  getToken() {
    return null
  },
  onNotificationTap() {
    return () => {}
  },
}
